import Authority from "@/enum/Authority";

const AuthorityNameMap = {
    [Authority.ROLE_ORDER_LIST]: "订单列表（解密订单、合并/拆分订单、修改备注、修改发货人）",

    [Authority.ROLE_ORDER_SEARCH]: "快速查单",

    [Authority.ROLE_REFUND_LIST]: "查看售后管理",

    [Authority.ROLE_REFUND_MANAGEMENT]: "售后处理（同意退款、同意退货、修改备注）",

    [Authority.ROLE_ORDER_PRINT]: "订单打印（获取/回收/删除运单号、修改快递公司）",

    [Authority.ROLE_ORDER_IMPORT]: "录入或批量导入手工订单",

    [Authority.ROLE_ORDER_OP_LOG]: "操作日志",

    [Authority.ROLE_ORDER_EXPORT]: "订单导出",

    [Authority.ROLE_WAYBILL_EXPORT]: "运单号导出",

    [Authority.ROLE_USER_MANAGEMENT]: "账号权限管理",

    [Authority.ROLE_SHOP_MANAGEMENT]: "店铺管理",

    [Authority.ROLE_PRODUCT_LIST]: "商品设置",

    [Authority.ROLE_SYSTEM_ADMIN]: "系统管理员",

    [Authority.ROLE_ADMIN_OM]: "管理后台-运营",

    [Authority.ROLE_ADMIN_CS]: "管理后台-客服",

    [Authority.ROLE_DROP_SHIPPING_REFUND_MANAGEMENT]: "代发退款管理",

    [Authority.ROLE_AUTO_PRINT]: "自动打印",

    [Authority.ROLE_ORDER_PRIVACY_CONSIGNEE_DECRYPT]: "查看/打印收货人明文信息",
};

export default AuthorityNameMap;
